module.exports = __webpack_public_path__ + "img/icon_start.dfc03e4f.png";